import * as React from "react";
const SvgClose = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M9.05 8L13 4.05L11.95 3L8 6.95L4.05 3L3 4.05L6.95 8L3 11.95L4.05 13L8 9.05L11.95 13L13 11.95L9.05 8Z" }));
export default SvgClose;
